import { createReducer, on } from '@ngrx/store';
import { ContactUsPageActions } from '../action';
import { ContactUsState } from '../contactUs-state';

export const initialState: ContactUsState = {
  formData: null,
  statusCode: null,
  validationStatus: null,
  fileData: null,
  loading: null,
  error: null,
  success: null,
};

export const ContactUsReducer = createReducer(
  initialState,

  on(ContactUsPageActions.submitForm, (state) => {
     return {
    ...state,
    loading: true,
    success: null,
    error: null
    
  };
}),

on(ContactUsPageActions.submitFormSuccess, (state, {statusCode}) => {
  return {
    ...state,
    statusCode,
    loading: null,
    success: true,
    error: null
  };
}),

on(ContactUsPageActions.submitFormFail, (state, { payload }) => {
  return {
    ...state, loading: null,
    success: null,
    error: payload
  };
}),

  on(ContactUsPageActions.uploadFile, (state, { uploadFile }) => {
    return {
      ...state, ...uploadFile
    };
  }),

  on(ContactUsPageActions.submitFormStatus, (state) => {
    return {
      ...state,
      loading: true,
      success: null,
      error: null
    };
  }),

  on(ContactUsPageActions.resetResponse, () => {
    return {
      ...initialState
    };
  }),

  on(ContactUsPageActions.fileType, (state, {fileData}) => {
    return {
      ...state, fileData
    };
  }),

  on(ContactUsPageActions.captchaValidation, (state, { validationStatus }) => {
    return {
      ...state,
      validationStatus,
    };
  })
);
